import EditIcon from "@mui/icons-material/Edit";

import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";

import { ROUTES_CONFIG } from "./config";
import { editRoute } from "redux/actions/buildings/routes/routesActions";
import { blue } from "@mui/material/colors";
import RegularButton from "components/CustomButtons/Button";

export const columns = [
  {
    Header: () => <span>{ROUTES_CONFIG.route.label}</span>,
    accessor: ROUTES_CONFIG.route.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CONFIG.route.key]
        ? row[ROUTES_CONFIG.route.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CONFIG.station.label}</span>,
    accessor: ROUTES_CONFIG.station.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CONFIG.station.key]
        ? row[ROUTES_CONFIG.station.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },
  {
    Header: () => <span>{ROUTES_CONFIG.employee.label}</span>,
    accessor: ROUTES_CONFIG.employee.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[ROUTES_CONFIG.employee.key]
        ? row[ROUTES_CONFIG.employee.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : ""
  },

  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editRoute(original));
      };
      return (
        <ColumnContainer>
          <RegularButton
            tooltip="Editar"
            round
            justIcon
            color="transparent"
            size="sm"
            onClick={openEdit}
          >
            <EditIcon style={{ color: blue[500] }} />
          </RegularButton>
        </ColumnContainer>
      );
    }
  }
];
